"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var typography_1 = __importDefault(require("@cdo/apps/componentLibrary/typography"));
var radioButton_module_scss_1 = __importDefault(require("./radioButton.module.scss"));
var constants_1 = require("@cdo/apps/componentLibrary/common/constants");
var RadioButton = function (_a) {
    var label = _a.label, checked = _a.checked, onChange = _a.onChange, name = _a.name, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'm' : _c;
    var bodyTextSize = constants_1.componentSizeToBodyTextSizeMap[size];
    return (react_1.default.createElement("label", { className: (0, classnames_1.default)(radioButton_module_scss_1.default.radioButton, radioButton_module_scss_1.default["radioButton-".concat(size)]) },
        react_1.default.createElement("input", { type: "radio", name: name, value: value, checked: checked, disabled: disabled, onChange: onChange }),
        react_1.default.createElement("i", { className: radioButton_module_scss_1.default.radioIcon }),
        label && (react_1.default.createElement(typography_1.default, { semanticTag: "span", className: radioButton_module_scss_1.default.radioButtonLabel, visualAppearance: bodyTextSize }, label))));
};
/**
 * ### Production-ready Checklist:
 * * (✔) implementation of component approved by design team;
 * * (✔) has storybook, covered with stories and documentation;
 * * (✔) has tests: test every prop, every state and every interaction that's js related;
 * * (see apps/test/unit/componentLibrary/RadioButtonTest.jsx, apps/test/unit/componentLibrary/RadioButtonsGroupTest.jsx)
 * * (?) passes accessibility checks;
 *
 * ###  Status: ```Ready for dev```
 *
 * Design System: Radio Button Component.
 * Can be used to render a single Radio Button or as a part of bigger/more complex components (e.g. Radio Button Group).
 */
exports.default = (0, react_1.memo)(RadioButton);
